export enum Launch_Hub_88 {
  "hu" = "hu",
}
